import { useMemo } from 'react';
import { UsePortfolioChartDataParams } from 'src/components/PortfolioPage/PortfolioTradeSubPage/types';
import {
	buildCumulativePnlBaseData,
	buildCumulativePnlLiveData,
} from 'src/components/PortfolioPage/PortfolioTradeSubPage/utils/buildCumulativePnlChartData';

export default function usePortfolioCumulativePnlChartData({
	enabled,
	snapshots,
	metrics,
	currentCumulativeFunding,
	currentUnrealizedPnl,
	includeFeesAndFunding,
	realizedPnlOnly,
}: UsePortfolioChartDataParams) {
	const cumulativeBase = useMemo(() => {
		return buildCumulativePnlBaseData({
			enabled,
			snapshots,
			includeFeesAndFunding,
			realizedPnlOnly,
		});
	}, [enabled, snapshots, includeFeesAndFunding, realizedPnlOnly]);

	const cumulativeLive = useMemo(() => {
		return buildCumulativePnlLiveData({
			enabled,
			metrics,
			currentCumulativeFunding,
			currentUnrealizedPnl,
			includeFeesAndFunding,
			realizedPnlOnly,
			startOfPeriodTotalPnl: cumulativeBase.startOfPeriodTotalPnl,
			startOfPeriodFeesAndFunding: cumulativeBase.startOfPeriodFeesAndFunding,
		});
	}, [
		enabled,
		metrics,
		currentCumulativeFunding,
		currentUnrealizedPnl,
		includeFeesAndFunding,
		realizedPnlOnly,
		cumulativeBase.startOfPeriodTotalPnl,
		cumulativeBase.startOfPeriodFeesAndFunding,
	]);

	return useMemo(() => {
		if (!cumulativeBase.series.length) {
			return cumulativeBase.series;
		}

		return [...cumulativeBase.series, cumulativeLive];
	}, [cumulativeBase.series, cumulativeLive]);
}
